import { Component, Input, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

@Component({
  selector: 'app-autoassigned-routine',
  templateUrl: './autoassigned-routine.component.html',
  styleUrls: ['./autoassigned-routine.component.scss'],
})
export class AutoassignedRoutineComponent implements OnInit {
  @Input() autoassignedRoutine: any = [];

  hoursDifference?: number;

  constructor() {}

  ngOnInit(): void {
    dayjs.extend(utc);

    const now = dayjs().utc();
    const routineTime = dayjs(this.autoassignedRoutine.createdAt).utc();

    this.hoursDifference = now.diff(routineTime, 'hours');
  }
}
